module.exports = __webpack_public_path__ + "static/media/reynold.3d4241f3.jpg";